/* src/app/private/components/leads/communication-note/communication-note.component.scss */
/*# sourceMappingURL=communication-note.component.css.map */
